import { Link } from "react-router-dom";
import { ArrowRight, Plus } from "lucide-react";
import { useSEO } from "../lib/seo";
import { Reveal } from "../lib/reveal";
import { SERVICES } from "../data/content";

const ServicesPage = () => {
  useSEO(
    "Services — BÂTI 360 | Rénovation, structure, couverture, isolation",
    "Une expertise complète pour vos travaux : rénovation intérieure, ouvertures de murs porteurs, couverture zinc, isolation et lots techniques à Paris et en Île-de-France."
  );

  return (
    <div className="pt-20 md:pt-24">
      <header className="border-b border-black/10 bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
              <span className="h-px w-10 bg-bati-sky" /> Prestations
            </p>
            <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl lg:text-6xl">
              Une expertise complète pour vos travaux
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-bati-ink/60">
              Du gros œuvre aux finitions, BÂTI 360 prend en charge l'ensemble des lots de votre chantier avec la même exigence.
            </p>
          </Reveal>
        </div>
      </header>

      <section className="bg-white">
        {SERVICES.map((service, i) => (
          <article key={service.slug} className={`border-b border-black/10 py-16 lg:py-24 ${i % 2 === 1 ? "bg-bati-mist" : ""}`} data-testid={`service-${service.slug}`}>
            <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 lg:grid-cols-2 lg:gap-16 lg:px-8">
              <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
                <div className="overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.04]"
                  />
                </div>
              </Reveal>
              <Reveal delay={0.12} className={i % 2 === 1 ? "lg:order-1" : ""}>
                <span className={`font-display text-sm font-bold ${service.green ? "text-bati-green" : "text-bati-sky"}`}>
                  0{i + 1}
                </span>
                <h2 className="mt-2 font-display text-3xl font-extrabold tracking-tight text-bati-ink sm:text-4xl">{service.title}</h2>
                <p className="mt-4 max-w-lg text-base leading-relaxed text-bati-ink/60">{service.text}</p>
                <ul className="mt-8 grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2">
                  {service.items.map((item) => (
                    <li key={item} className="flex items-center gap-2.5 border-b border-black/10 pb-3 text-sm font-medium text-bati-ink/75">
                      <Plus className={`h-3.5 w-3.5 shrink-0 ${service.green ? "text-bati-green" : "text-bati-sky"}`} strokeWidth={2.5} />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/realisations?cat=${service.filter}`}
                  data-testid={`service-link-${service.slug}`}
                  className="group mt-8 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-bati-blue transition-colors hover:text-bati-sky"
                >
                  Voir les réalisations associées
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Reveal>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default ServicesPage;
